import { Component, Input, OnInit, Output, EventEmitter, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { isNil } from "lodash";
interface Option {
  label: string;
  value: any;
}

export const CASCADE_TIME_PICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CascadedTimePickerV2Component),
  multi: true,
};

@Component({
  selector: "host-cascaded-time-picker-v2",
  templateUrl: "./cascaded-time-picker-v2.component.html",
  styleUrls: ["./cascaded-time-picker-v2.component.scss"],
  providers: [CASCADE_TIME_PICKER_VALUE_ACCESSOR],
})
export class CascadedTimePickerV2Component implements OnInit, ControlValueAccessor {
  @Input() listOfOptions: [Option[], Option[]] = [[], []];
  @Input() placeholder = "请选择";
  @Input() size: "small" | "large" | "default" = "default";
  @Output() onSelect = new EventEmitter();
  @Input()
  set value(v) {
    if (v) {
      this.leftValue = v[0];
      this.rightValue = v[1];
      this.updateRenderText();
      // this.renderText = this.getRenderText();
    }
  }
  get value() {
    return [this.leftValue, this.rightValue];
  }
  visible = false;

  leftValue;
  rightValue;

  renderText;

  trackByValue = (opt) => opt.value;
  _registerOnChange: (value: any) => void = (v: any) => {};
  constructor() {}

  ngOnInit() {}

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(obj: number[]): void {
    if (obj) {
      this.leftValue = obj[0];
      this.rightValue = obj[1];
    }
    this.updateRenderText();
  }

  onSelectLeft(value) {
    this.leftValue = value;
    this.updateRenderText();
  }

  onSelectRight(value) {
    this.rightValue = value;
    this.updateRenderText();
  }

  onVisibleChange(visible) {
    if (!visible) {
      if (!isNil(this.leftValue) && !isNil(this.rightValue)) {
        // this.renderText = this.getRenderText();
        this.onSelect.emit(this.value);

        this._registerOnChange(this.value);
      }
    }
  }

  private getRenderText() {
    const [lo, ro] = this.listOfOptions;
    const left = lo.find((o) => o.value === this.leftValue);
    const right = ro.find((o) => o.value === this.rightValue);
    return `${left.value === 0 ? "" : left.label}${right.label}`;
  }

  private updateRenderText() {
    const [lo, ro] = this.listOfOptions;
    const left = lo.find((o) => o.value === this.leftValue);
    const right = ro.find((o) => o.value === this.rightValue);

    let text = "";
    if (left) {
      text = left.value === 0 ? "" : left.label;
    }
    if (right) {
      text = text + " " + right.label;
    }
    this.renderText = text;
  }
}
